import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";
import { strokeDashTypes } from "../utils";

class BollingerPercentBSeries extends Component {
  render() {
    const { className, stroke, onContextMenu, showZones } = this.props;
    const { yAccessor } = this.props;
    const { overBought, middle, overSold } = this.props;

    // Extract numeric values and stroke properties from ThresholdLineType objects
    const extractThresholdValue = (prop, defaultValue, defaultStroke) => {
      if (typeof prop === "number") {
        return { value: prop, stroke: defaultStroke };
      }
      if (prop && typeof prop === "object") {
        if (prop.value !== undefined && prop.stroke) {
          return { value: prop.value, stroke: prop.stroke };
        }
        const keys = Object.keys(prop);
        if (keys.length === 1) {
          return { value: prop[keys[0]], stroke: defaultStroke };
        }
        if (prop.value !== undefined) {
          return { value: prop.value, stroke: defaultStroke };
        }
        if (prop.defaultValue !== undefined) {
          return { value: prop.defaultValue, stroke: defaultStroke };
        }
      }
      return { value: defaultValue, stroke: defaultStroke };
    };

    const overBoughtData = extractThresholdValue(overBought, 100, {
      color: "#B8C2CC",
      dash: "ShortDash",
      width: 1,
      opacity: 1,
    });
    const overSoldData = extractThresholdValue(overSold, 0, {
      color: "#B8C2CC",
      dash: "ShortDash",
      width: 1,
      opacity: 1,
    });
    const middleData = middle
      ? extractThresholdValue(middle, 50, {
          color: "#8795A1",
          dash: "ShortDash",
          width: 1,
          opacity: 1,
        })
      : null;

    // Handle both simple stroke object and complex stroke structure
    const percentBStroke = stroke.line ? stroke.line : stroke;

    // Determine if zones should be shown (default to true)
    const shouldShowZones = showZones !== false;

    return (
      <g className={className}>
        {shouldShowZones && (
          <StraightLine
            stroke={overSoldData.stroke}
            yValue={overSoldData.value}
            onContextMenu={onContextMenu}
          />
        )}
        {shouldShowZones && middleData && (
          <StraightLine
            stroke={middleData.stroke}
            yValue={middleData.value}
            onContextMenu={onContextMenu}
          />
        )}
        {shouldShowZones && (
          <StraightLine
            stroke={overBoughtData.stroke}
            yValue={overBoughtData.value}
            onContextMenu={onContextMenu}
          />
        )}
        <LineSeries
          className={className}
          yAccessor={yAccessor}
          stroke={percentBStroke}
          onContextMenu={onContextMenu}
        />
      </g>
    );
  }
}

BollingerPercentBSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  stroke: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      opacity: PropTypes.number,
      width: PropTypes.number,
      dash: PropTypes.oneOf(strokeDashTypes),
    }),
    PropTypes.shape({
      line: PropTypes.shape({
        color: PropTypes.string,
        opacity: PropTypes.number,
        width: PropTypes.number,
        dash: PropTypes.oneOf(strokeDashTypes),
      }),
    }),
  ]).isRequired,
  overSold: PropTypes.number,
  middle: PropTypes.number,
  overBought: PropTypes.number,
  showZones: PropTypes.bool,
  onContextMenu: PropTypes.func,
};

BollingerPercentBSeries.defaultProps = {
  className: "react-stockcharts-bollinger-percent-b-series",
  stroke: { color: "#9C27B0", opacity: 1, width: 1, dash: "Solid" },
  overSold: 0,
  overBought: 100,
  middle: 50,
  showZones: true,
};

export default BollingerPercentBSeries;
